import { render } from "./Index.vue?vue&type=template&id=181cf13e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=181cf13e&scoped=true&lang=css"

import exportComponent from "/Users/home/Projects/creelayer/mosquito/mosquito.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181cf13e"]])

export default __exports__